export const NEWS_WIDGET_FILTER_ICON_SIZE = '18px';
